import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img-web/banner@2x.png';
import _imports_1 from '@/assets/img-web/integration-img.png';
import _imports_2 from '@/assets/img-web/access@2x.png';
const _withScopeId = n => (_pushScopeId("data-v-16d56cb4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header",
  id: "header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner",
  id: "banner",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = {
  class: "website-container"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "极简接入 快速集成"), /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle"
}, " 火花学院提供标准化接口，可以让你的产品快速开发集成火花学院素材库。让你的用户可以使用全球领先的科学可视化资源库，为客户提供更多价值。 ")], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "跨平台访问"), /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle"
}, " 火花学院素材库使用了跨平台技术，无论你的产品在任何平台上，都可以使用。 ")], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "跨平台访问"), /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle"
}, " 火花学院素材库使用了跨平台技术，无论你的产品在任何平台上，都可以使用。 ")], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "products-description"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "没有开发能力？快速使用火花产品。"), /*#__PURE__*/_createElementVNode("span", {
  class: "subtitle"
}, "我们提供火花客户端，火花 PPT 插件，校本机构门户网站，你也可以选择直接使用火花的产品，将火花产品直接打包一起交付客户。")], -1));
const _hoisted_11 = ["onMouseover", "onMouseleave", "onTouchend"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "product-title"
};
const _hoisted_14 = {
  class: "desc-title"
};
const _hoisted_15 = {
  class: "desc-subtitle"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "合作伙伴", -1));
const _hoisted_17 = {
  class: "partners-img"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "常见问题", -1));
const _hoisted_20 = {
  key: 0,
  class: "problems-collapse"
};
const _hoisted_21 = {
  class: "answer"
};
const _hoisted_22 = {
  class: "more"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "applyDeveloper"
}, null, -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "申请成为开发者", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle"
}, "请填写联系方式，我们将在 1 个工作日内与您联系。", -1));
const _hoisted_26 = {
  class: "form"
};
const _hoisted_27 = {
  class: "code-input"
};
const _hoisted_28 = {
  class: "code-input"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "error-tip"
};
const _hoisted_31 = {
  class: "footer"
};
const _hoisted_32 = {
  class: "left"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, "皖ICP备17024836号", -1));
const _hoisted_34 = {
  key: 1,
  class: "phone-foot"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "device-number"
}, "皖ICP备17024836号", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_el_collapse = _resolveComponent("el-collapse");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_footer = _resolveComponent("el-footer");
  return _openBlock(), _createElementBlock("div", {
    class: "website-home",
    onScroll: _cache[28] || (_cache[28] = $event => _ctx.scroll())
  }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_row, {
    class: "banner-text"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "title"
    }, {
      default: _withCtx(() => [_createTextVNode("立即接入全球领先的科学可视化教学资源库")]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "subtitle"
    }, {
      default: _withCtx(() => [_createTextVNode("轻松构建覆盖全学段内容资源的教育应用，为你的产品充分赋能")]),
      _: 1
    }), _createVNode(_component_el_button, {
      class: "become-developer",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.goApply())
    }, {
      default: _withCtx(() => [_createTextVNode("申请成为开发者")]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
    class: "integration"
  }, {
    default: _withCtx(() => [_hoisted_4, _hoisted_5]),
    _: 1
  }), !_ctx.changePage ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "access"
  }, {
    default: _withCtx(() => [_hoisted_6, _hoisted_7]),
    _: 1
  })) : _createCommentVNode("", true), _ctx.changePage ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "access"
  }, {
    default: _withCtx(() => [_hoisted_8, _hoisted_9]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    class: "huohua-product"
  }, {
    default: _withCtx(() => [_hoisted_10, _createVNode(_component_el_col, {
      class: "products"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.huohuaProducts, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "product",
          key: index,
          onMouseover: $event => _ctx.productFocus(item),
          onMouseleave: $event => _ctx.productBlur(item),
          onTouchend: $event => _ctx.setShowDescription(item, $event)
        }, [_createElementVNode("img", {
          class: "product-img",
          src: item.icon,
          alt: ""
        }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1), _createElementVNode("div", {
          class: _normalizeClass(["product-desc", {
            showDesc: item.showDescription,
            hideDesc: !item.showDescription
          }])
        }, [_createElementVNode("span", _hoisted_14, _toDisplayString(item.desc.title), 1), _createElementVNode("span", _hoisted_15, _toDisplayString(item.desc.subtitle), 1)], 2)], 40, _hoisted_11);
      }), 128))]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "partners"
  }, {
    default: _withCtx(() => [_hoisted_16, _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnersIcon, (icon, index) => {
      return _openBlock(), _createElementBlock("img", {
        key: index,
        src: icon.icon,
        alt: ""
      }, null, 8, _hoisted_18);
    }), 128))])]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "problems"
  }, {
    default: _withCtx(() => [_hoisted_19, _ctx.problems.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_el_collapse, {
      class: "collapse",
      accordion: ""
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.problems, (item, index) => {
        return _openBlock(), _createBlock(_component_el_collapse_item, {
          class: "collapse-item",
          key: index,
          title: item.title,
          name: item.name
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_21, _toDisplayString(item.answer), 1)]),
          _: 2
        }, 1032, ["title", "name"]);
      }), 128))]),
      _: 1
    })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createTextVNode(" 更多常见问题请参阅"), _createElementVNode("span", {
      class: "doc",
      onClick: _cache[1] || (_cache[1] = $event => _ctx.openDoc())
    }, "开发与帮助文档")])]),
    _: 1
  }), _hoisted_23, _createVNode(_component_el_row, {
    class: "apply"
  }, {
    default: _withCtx(() => [_hoisted_24, _hoisted_25, _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_form, {
      ref: "ruleFormRef",
      model: _ctx.applyObject,
      rules: _ctx.rules,
      "label-width": "120px",
      class: "demo-ruleForm",
      size: _ctx.formSize
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        prop: "companyName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.applyObject.companyName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.applyObject.companyName = $event),
          maxlength: 40,
          placeholder: "请输入公司/机构名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        prop: "phone",
        rules: [{
          type: 'number',
          validator: _ctx.checkPhone,
          message: '请输入正确11位手机号',
          trigger: 'blur'
        }]
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.applyObject.phone,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.applyObject.phone = $event),
          maxlength: 11,
          placeholder: "请输入手机号码"
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["rules"]), _createVNode(_component_el_form_item, {
        prop: "name"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.applyObject.name,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.applyObject.name = $event),
          maxlength: 40,
          placeholder: "请输入联系人姓名"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        prop: "email",
        rules: [{
          type: 'number',
          validator: _ctx.checkEmail,
          message: '请输入正确邮箱',
          trigger: 'blur'
        }]
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.applyObject.email,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.applyObject.email = $event),
          maxlength: 50,
          placeholder: "请输入正确邮箱"
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["rules"]), _createVNode(_component_el_form_item, {
        prop: "province"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.applyObject.province,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.applyObject.province = $event),
          class: "province-select",
          "popper-class": "province-popper",
          clearable: "",
          placeholder: "请选择省",
          onChange: _cache[7] || (_cache[7] = $event => _ctx.changeProvince())
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinceList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.regionName,
              value: item.regionName
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.applyObject.city,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.applyObject.city = $event),
          class: "province-select",
          "popper-class": "province-popper",
          clearable: "",
          placeholder: "请选择市",
          onChange: _cache[9] || (_cache[9] = $event => _ctx.changeCity())
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cityList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.regionName,
              value: item.regionName
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.applyObject.district,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _ctx.applyObject.district = $event),
          class: "province-select",
          "popper-class": "province-popper",
          clearable: "",
          placeholder: "请选择区"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.regionName,
              value: item.regionName
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          class: "confirm",
          onClick: _cache[11] || (_cache[11] = $event => _ctx.submitForm(_ctx.ruleFormRef)),
          onMouseleave: _cache[12] || (_cache[12] = $event => _ctx.leaveBtn()),
          onTouchend: _cache[13] || (_cache[13] = $event => _ctx.leaveBtn())
        }, {
          default: _withCtx(() => [_createTextVNode("提交")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules", "size"])])]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    class: "dialog",
    onClose: _cache[20] || (_cache[20] = $event => _ctx.clearInfo()),
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _ctx.showDialog = $event),
    title: "申请成为开发者",
    center: "",
    width: "320px",
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_createVNode(_component_el_input, {
      class: "input-style",
      modelValue: _ctx.applyObject.phone,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _ctx.applyObject.phone = $event),
      disabled: ""
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_input, {
      class: "input-style",
      modelValue: _ctx.imgCodeText,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _ctx.imgCodeText = $event)
    }, null, 8, ["modelValue"]), _createElementVNode("img", {
      class: "get-code",
      src: _ctx.imgCodeSrc,
      onClick: _cache[16] || (_cache[16] = $event => _ctx.getImageCode())
    }, null, 8, _hoisted_29)]), _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.errorTip), 1), _createVNode(_component_el_button, {
      class: "confirm dialog-confirm",
      onClick: _cache[17] || (_cache[17] = $event => _ctx.submit()),
      loading: _ctx.btnLoading,
      onMouseleave: _cache[18] || (_cache[18] = $event => _ctx.leaveBtn()),
      onTouchend: _cache[19] || (_cache[19] = $event => _ctx.leaveBtn())
    }, {
      default: _withCtx(() => [_createTextVNode("提交")]),
      _: 1
    }, 8, ["loading"])]),
    _: 1
  }, 8, ["modelValue"])]), !_ctx.showPhoneFooter ? (_openBlock(), _createBlock(_component_el_footer, {
    key: 0,
    class: "website-el-footer"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("span", {
      onClick: _cache[22] || (_cache[22] = $event => _ctx.toHuoHua()),
      style: {
        "margin-right": "10px"
      }
    }, "火花学院"), _createTextVNode("| "), _createElementVNode("span", {
      onClick: _cache[23] || (_cache[23] = $event => _ctx.policy()),
      style: {
        "display": "inline-block",
        "margin": "0 10px"
      }
    }, "隐私保护政策"), _createTextVNode("| "), _createElementVNode("span", {
      onClick: _cache[24] || (_cache[24] = $event => _ctx.about()),
      style: {
        "display": "inline-block",
        "margin-left": "10px"
      }
    }, "关于我们")]), _hoisted_33])]),
    _: 1
  })) : _createCommentVNode("", true), _ctx.showPhoneFooter ? (_openBlock(), _createElementBlock("ul", _hoisted_34, [_createElementVNode("li", {
    onClick: _cache[25] || (_cache[25] = $event => _ctx.toHuoHua())
  }, "火花学院"), _createElementVNode("li", {
    onClick: _cache[26] || (_cache[26] = $event => _ctx.policy())
  }, "隐私保护政策"), _createElementVNode("li", {
    onClick: _cache[27] || (_cache[27] = $event => _ctx.about())
  }, "关于我们"), _hoisted_35])) : _createCommentVNode("", true)], 32);
}